export class ILLRevisionHistory {
  llRevisionId: number;
  version: string;
  modifiedBy: string;
  modifiedDate: string;
  activeFlag: string;
}
